import { container, createCookie } from '@mtfe/sweet-utils';
import {
    addLoginError,
    addLoginSuccess,
    LoginSource,
    addCustomPoint,
    addLog,
    createBaseTags,
    addError,
    reportLog,
    createUnionId,
    getPageName,
    reportReConfig,
    getMetricInstance,
} from '@mtfe/sweet-report';

const { isMiniProgramTuan, isMiniProgramWaimai } = container;
const Cookies = createCookie();

function _getNewUrl(url) {
    addLog(`_getNewUrl url start: =>${url}`);
    let queryArr = ['wxapp_force_login=1'];
    const curUrl = new URL(url);
    curUrl.searchParams.forEach((value, key) => {
        if (key !== 'wxapp_force_login' && key !== '__lxsdk_params' && key !== 'privacySwitches') {
            queryArr.push(`${key}=${value}`);
        }
    });

    const newUrl = `${curUrl.origin}${curUrl.pathname}?${queryArr.join('&')}`;
    addLog(`_getNewUrl url end: =>${newUrl}`);
    return newUrl;
}

function _getUrlParam(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var match = window.location.search.substr(1).match(reg);
    return match != null ? decodeURIComponent(match[2]) : null;
}

function _toReportString(value) {
    // 更改函数名称
    if (value === null) {
        return 'null'; // null 转为字符串 "null"
    }
    if (value === undefined) {
        return 'undefined'; // undefined 转为字符串 "undefined"
    }
    if (typeof value === 'object') {
        try {
            return JSON.stringify(value); // 对象和数组转为 JSON 字符串
        } catch (e) {
            return '[object Object]'; // 如果 JSON.stringify 失败，返回默认字符串
        }
    }
    return String(value); // 其他类型直接转为字符串
}

let clickCount = 0;
function miniProgramLogin(url) {
    addLog('isMiniProgramTuan , isMiniProgramWaimai: => ', isMiniProgramTuan, isMiniProgramWaimai);
    if (isMiniProgramTuan || isMiniProgramWaimai) {
        if (!url) {
            url = window.location.href;
        }

        const handledUrl = _getNewUrl(url);
        addLog('handledUrl: => ', handledUrl);
        const path = `${isMiniProgramTuan ? '/waimai-mt' : ''}/pages/web-view/web-view?type=REDIRECT&webviewUrl=${encodeURIComponent(handledUrl)}`;
        addLog('path: => ', path);
        wx.miniProgram.redirectTo({
            url: path,
            fail: function (res) {
                const msg = `小程序重定向失败:${_toReportString(res)}`;
                const tags = createBaseTags();
                addError({ name: '小程序重定向失败', msg }, tags);
                addLog({
                    title: '小程序重定向失败',
                    msg,
                    tags,
                });
                addCustomPoint('miniProgramRedirectError', 1);
            },
            success: function (res) {
                const msg = `小程序重定向成功:${_toReportString(res)}`;
                const tags = createBaseTags();
                clickCount += 1;
                addLog('clickCount: => ', clickCount);
                // 更改上报的配置，以在跳转之前完成上报，正常metric延迟为1500ms
                reportReConfig({
                    error: {
                        sample: 1,
                        delay: 0,
                    },
                    metric: {
                        sample: 1,
                        delay: 0,
                        combo: false,
                    },
                });

                addLog({
                    title: '小程序重定向成功',
                    msg,
                    tags,
                });
                addCustomPoint('miniProgramRedirectSuccess', 1);
            },
            complete: function () {
                const pageName = getPageName();
                const unionId = createUnionId(pageName);
                const instance = getMetricInstance();

                if (instance && instance.report) {
                    instance.report();
                }

                reportLog({ unionId });
            },
        });
    }
}

function hasWxappLoginStatus() {
    return _getUrlParam('wxapp_login_status') !== null;
}

function miniProgramLoginReady() {
    if (isMiniProgramTuan || isMiniProgramWaimai) {
        if (_getUrlParam('wxapp_force_login') == 1) {
            // 从登录url进来
            if (_getUrlParam('wxapp_login_status') == 0) {
                // 0:登录状态成功
                const token = _getUrlParam('wm_logintoken'); // 登录token
                if (token) {
                    // 写cookie
                    Cookies.set('wm_logintoken', token); // mt_c_token，后端从这里取token
                    // 小程序登录成功，上报成功
                    addLoginSuccess(LoginSource.miniProgram);
                } else {
                    // 小程序登录失败（token异常），进行上报
                    addLoginError(LoginSource.miniProgram, '获取token异常,url未传token');
                }
            } else if (_getUrlParam('wxapp_login_status') == 1) {
                // 1:登录状态失败
                // 小程序登录失败（被拒绝），进行上报
                addLoginError(LoginSource.miniProgram, '用户拒绝授权登录');
            } else {
                addLoginError(LoginSource.miniProgram, 'wxapp_login_status参数缺失');
            }
        }
    }
}

const oadWX = {
    miniProgramLogin,
    miniProgramLoginReady,
    isMiniProgramLoginReject: _getUrlParam('wxapp_login_status') == 1,
    isMiniProgramLoginForce: _getUrlParam('wxapp_force_login') == 1,
    hasWxappLoginStatus,
};

export default oadWX;
